import { Injectable } from "@angular/core";
import { IShellPopoverLinkItem } from "@common/shell/shell-popover-link-item/shell-popover-link-item";
import { ResponsiveService } from "@common/ux/responsive/responsive.service";
import { map, Observable } from "rxjs";
import { ActivityNotificationContentComponent } from "../activity-notification-content/activity-notification-content.component";
import { ActivityNotificationComponent } from "./activity-notification.component";

@Injectable()
export class ApplicationBarNotificationItem implements IShellPopoverLinkItem {
    public readonly linkContent = {
        component: ActivityNotificationComponent,
    };
    public readonly popover = {
        component: ActivityNotificationContentComponent,
    };
    public readonly ordinal = 999; // between search/coach and person profile
    public readonly isShown$: Observable<boolean>;
    public readonly isInternal = true;

    public constructor(
        responsiveService: ResponsiveService,
    ) {
        this.isShown$ = responsiveService.currentBreakpoint$.pipe(
            map((b) => b.isDesktopSize),
        );
    }
}
